import { setupLazyLoad } from './lazy-load';
import { setupMenu } from './menu';
import { setupStopReferrerHack } from './stop-referrer-hack';
import { setupToggles } from './toggles';

export function setup($: JQueryStatic) {
  setupStopReferrerHack();
  setupToggles();
  setupLazyLoad();
  setupMenu($);
}
